module.exports = __webpack_public_path__ + "static/media/mausam - dust raising winds.e0d6c20f.png";